/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'
import { capitalize } from 'lodash'

import { EuiBadge } from '@elastic/eui'

import CloudResourceItem from './CloudResourceItem'

import type { Budget } from '../../types'

type Props = {
  color?: 'default' | 'hollow'
  scopeType: Budget['scope_type']
  scopeValues: Budget['scope_values']
}

const ScopeItem: FunctionComponent<Props> = ({ color = 'default', scopeType, scopeValues }) => {
  if (scopeType === 'organization') {
    return <EuiBadge color={color}>{capitalize(scopeType)}</EuiBadge>
  }

  const scopeValue = scopeValues[0]!

  return <CloudResourceItem scopeValue={scopeValue} />
}

export default ScopeItem
